/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * PG作成レスポンス
 * @export
 * @interface CreateGroup200Response
 */
export interface CreateGroup200Response {
    /**
     * ペイメントグループID
     * @type {number}
     * @memberof CreateGroup200Response
     */
    groupId: number;
}

/**
 * Check if a given object implements the CreateGroup200Response interface.
 */
export function instanceOfCreateGroup200Response(value: object): value is CreateGroup200Response {
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    return true;
}

export function CreateGroup200ResponseFromJSON(json: any): CreateGroup200Response {
    return CreateGroup200ResponseFromJSONTyped(json, false);
}

export function CreateGroup200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateGroup200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'groupId': json['group_id'],
    };
}

export function CreateGroup200ResponseToJSON(json: any): CreateGroup200Response {
    return CreateGroup200ResponseToJSONTyped(json, false);
}

export function CreateGroup200ResponseToJSONTyped(value?: CreateGroup200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_id': value['groupId'],
    };
}

